import styled from 'styled-components/macro';

export const GreenIdContainer = styled.div`

  color: ${({ theme }) => theme.colors.text.primary};
  padding-top: 5%;

  p {
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: ${({ theme }) => theme.font.size.large};
  }
`
export const GreenIdUi = styled.div`
    padding: 5%;
    background-color: white;
    border-radius: 10px;
    div {
        background-color: white;
    }
`